<template>
    <div class="ProcessSubview">
        <QCard
            bordered
            class="ProcessSubviewCard"
        >
            <QCardSection>
                <Conformance
                    :key="reloadKey"
                    :processId="processId"
                    :projectId="projectId"
                    :attributes="attributes"
                    :filteredTraces="filteredTraces"
                    :modelId="modelId"
                    :hasModels="hasModels"
                />
            </QCardSection>
        </QCard>

        <ModelPreview
            :show="previewShown"
            :bpmnData="previewData"
            @close-preview="handleCloseModelPreview"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { Api, apiRequest, notifyError } from '@/api'
import { ModelPreview } from '@/screens/Project/Models/sections'
import Conformance from '../Conformance/Conformance.vue'

export default {
    name: 'ConformanceSubview',
    components: { Conformance, ModelPreview },
    props: {
        processId: VueTypes.any,
        attributes: VueTypes.array,
        infoFiltered: VueTypes.object,
    },
    data() {
        return {
            reloadKey: 0,
            modelId: undefined,
            models: [],
            modelsLoaded: false,
            previewShown: false,
            previewData: undefined,
        }
    },
    computed: {
        projectId() {
            return this.$route?.params?.projectId
        },
        filteredTraces() {
            return this.infoFiltered?.cases || 0
        },
        hasModels() {
            const count = (this.models || []).length
            // If we already have models in memory, keep the view usable even if a refresh is in-flight.
            if (count > 0) return true
            if (!this.modelsLoaded) return undefined
            return false
        },
    },
    watch: {
        processId: {
            handler() {
                this.modelId = undefined
                this.models = []
                this.modelsLoaded = false
                this.previewShown = false
                this.previewData = undefined
            },
        },
        filteredTraces: {
            handler(value) {
                // When we have traces but no models loaded yet, avoid showing a fixed "no models"
                // message while the drawer is still fetching the model list.
                if ((Number(value) || 0) > 0 && (this.models || []).length === 0) {
                    this.modelsLoaded = false
                }
            },
        },
    },
    methods: {
        reloadCurrentView() {
            this.reloadKey += 1
        },

        setConformanceModelsInfo({ models } = {}) {
            this.models = Array.isArray(models) ? models : []
            this.modelsLoaded = true
        },
        setConformanceModelId(modelId) {
            this.modelId = modelId
        },
        setConformanceModelName({ modelId, modelName } = {}) {
            if (!modelId || !modelName) return
            const idx = (this.models || []).findIndex((m) => `${m.value}` === `${modelId}`)
            if (idx >= 0) {
                this.models.splice(idx, 1, { ...this.models[idx], label: modelName })
            }
        },

        async openConformanceModelPreview({ modelId, modelName } = {}) {
            if (!modelId) return
            try {
                const { bpmn } = await apiRequest(Api().models.get({ modelId }))
                const resolvedName = modelName || (this.models || []).find((m) => `${m.value}` === `${modelId}`)?.label
                this.previewData = {
                    modelName: resolvedName || `${modelId}`,
                    bpmn,
                }
                this.previewShown = true
            } catch (e) {
                notifyError(e)
            }
        },
        handleCloseModelPreview() {
            this.previewShown = false
        },
    },
}
</script>

<style scoped lang="scss">
.ProcessSubview {
    height: 100%;
}

.ProcessSubviewCard {
    height: 100%;
}
</style>
